import actionTypes from '../constants/action-types';
import globals from '../../globals';
import DEFAULT_OPTIONS from '../constants/default-options';

const removeElementAttribute = (elementId, attr, options = DEFAULT_OPTIONS) =>
  globals.helpers.globalActionExtender({
    type: actionTypes.REMOVE_ELEMENT_ATTRIBUTE,
    payload: {
      elementId,
      attr,
      options,
    },
  });

export default removeElementAttribute;
